import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

export const MetricCard = ({ label, value, unit, icon: Icon, trend, subtext, className = '' }) => {
  const isPositive = trend && trend > 0;
  const isNegative = trend && trend < 0;

  return (
    <div 
      className={`bg-white border border-border rounded-md p-6 hover:-translate-y-1 hover:shadow-md transition-all duration-200 hover:border-primary/20 ${className}`}
      data-testid={`metric-card-${label.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="flex items-start justify-between mb-2">
        <div className="text-xs tracking-[0.2em] uppercase font-semibold text-text-secondary">
          {label}
        </div>
        {Icon && <Icon className="h-5 w-5 text-text-muted" />}
      </div>
      
      <div className="flex items-baseline space-x-2">
        <div className="text-3xl font-bold text-primary tracking-tight">
          {value}
        </div>
        {unit && <span className="text-sm text-text-muted">{unit}</span>}
      </div>

      {trend !== undefined && (
        <div className={`mt-2 flex items-center text-sm ${
          isPositive ? 'text-state-success' : 
          isNegative ? 'text-state-error' : 
          'text-text-muted'
        }`}>
          {isPositive && <TrendingUp className="h-4 w-4 mr-1" />}
          {isNegative && <TrendingDown className="h-4 w-4 mr-1" />}
          <span>{Math.abs(trend)}% vs last period</span>
        </div>
      )}
      {subtext && trend === undefined && (
        <div className="mt-2 text-xs text-text-muted" data-testid="metric-subtext">
          {subtext}
        </div>
      )}
    </div>
  );
};